export default "__VITE_ASSET__CjNJnYun__"